import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgPlusIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12.0005 4.00037C12.4146 4.00054 12.7505 4.33626 12.7505 4.75037V11.2504H19.2505C19.6646 11.2505 20.0005 11.5863 20.0005 12.0004C20.0003 12.4143 19.6644 12.7502 19.2505 12.7504H12.7505V19.2504C12.7503 19.6643 12.4144 20.0002 12.0005 20.0004C11.5864 20.0004 11.2507 19.6644 11.2505 19.2504V12.7504H4.75049C4.33638 12.7504 4.00066 12.4144 4.00049 12.0004C4.00049 11.5862 4.33628 11.2504 4.75049 11.2504H11.2505V4.75037C11.2505 4.33615 11.5863 4.00037 12.0005 4.00037Z"
            fill="#5F47F6"
        />
    </svg>
);

export const PlusIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgPlusIcon}
        fontSize={fontSize}
    />
);
